import AppNav from 'components/main/app-nav/AppNav';
import * as lodash from 'lodash';
import AgricultureOverviewPage from 'pages/agriculture/overview/AgricultureOverviewPage';
import AgriculturePage from 'pages/agriculture/AgriculturePage';
import SaleDatalistPage from 'pages/agriculture/sale/SaleDatalistPage';
import SaleFormPage from 'pages/agriculture/sale/SaleFormPage';
import SalePage from 'pages/agriculture/sale/SalePage';
import SaleViewPage from 'pages/agriculture/sale/SaleViewPage';
import HarvestsFormPage from 'pages/agriculture/work/HarvestsFormPage';
import HarvestListPage from 'pages/agriculture/work/HarvestListPage';
import WorkPage from 'pages/agriculture/work/WorkPage';
import WorkViewPage from 'pages/agriculture/work/WorkViewPage';
import AppIndex from "pages/AppIndex";
import AppPrinter from "pages/AppPrinter";
import Dashboard from 'pages/Dashboard';
import DemoPage from "pages/demo/DemoPage";
import PersonDatalistPage from 'pages/person/PersonDatalistPage';
import PersonFormPage from "pages/person/PersonFormPage";
import PersonPage from 'pages/person/PersonPage';
import PersonViewPage from "pages/person/PersonViewPage";
import ProfileFormPage from "pages/profile/ProfileFormPage";
import ProfilePage from "pages/profile/ProfilePage";
import SeasonDatalistPage from 'pages/season/SeasonDatalistPage';
import SeasonFormPage from 'pages/season/SeasonFormPage';
import SeasonPage from 'pages/season/SeasonPage';
import SeasonViewPage from 'pages/season/SeasonViewPage';
import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import AgricultureStatsPage from 'pages/agriculture/overview/AgricultureStatsPage';
import AgricultureOtherPage from 'pages/agriculture/overview/AgricultureOtherPage';
import FruitPage from 'pages/agriculture/fruit/FruitPage';
import FruitFormPage from 'pages/agriculture/fruit/FruitFormPage';
import TemplatePage from 'pages/template/TemplatePage';
import WorkTemplateFormPage from 'pages/template/agriculture/WorkTemplateFormPage';
import SaleTemplateFormPage from 'pages/template/agriculture/SaleTemplateFormPage';
import SettingsPage from 'pages/settings/SettingsPage';
import UserDatalistPage from 'pages/settings/users/UserDatalistPage';
import UnauthorizedPage from 'pages/UnauthorizedPage';
import { Roles } from 'utilities/app-utilities';
import { IUser } from 'types/user-type';
import UserPage from 'pages/settings/users/UserPage';
import UserFormPage from 'pages/settings/users/UserFormPage';
import UserViewPage from 'pages/settings/users/UserViewPage';
import SaleMultiUpdatePage from 'pages/agriculture/sale/SaleMultiUpdatePage';
import HarvestMultiUploadPage from 'pages/agriculture/work/details/HarvestMultiUploadPage';
import AgricultureInvestmentDatalistPage from 'pages/agriculture/work/investments/AgricultureInvestmentDatalistPage';
import AgricultureMaintenanceDatalistPage from 'pages/agriculture/work/maintenance/AgricultureMaintenanceDatalistPage';
import AgricultureInvestmentViewPage from 'pages/agriculture/work/investments/AgricultureInvestmentViewPage';
import AgricultureInvestmentFormPage from 'pages/agriculture/work/investments/AgricultureInvestmentFormPage';
import AgricultureInvestmentHome from 'pages/agriculture/work/investments/AgricultureInvestmentHomePage';
import AgricultureMaintenanceHomePage from 'pages/agriculture/work/maintenance/AgricultureMaintenanceHomePage';
import AgricultureMaintenanceViewPage from 'pages/agriculture/work/maintenance/AgricultureMaintenanceViewPage';
import AgricultureMaintenanceFormPage from 'pages/agriculture/work/maintenance/AgricultureMaintenanceFormPage';
import AgricultureMaintenanceTypeHomePage
    from 'pages/agriculture/work/maintenance/types/AgricultureMaintenanceTypeHomePage';
import AgricultureMaintenanceTypeFormPage
    from 'pages/agriculture/work/maintenance/types/AgricultureMaintenanceTypeFormPage';
import PersonTagDatalistPage from 'pages/person/tags/PersonTagDatalistPage';
import PersonTagPage from 'pages/person/tags/PersonTagPage';
import PersonTagFormPage from 'pages/person/tags/PersonTagFormPage';
import PersonTagViewPage from 'pages/person/tags/PersonTagViewPage';
import AccommodationPage from 'pages/accommodation/AccommodationPage';
import AccommodationOverviewPage from 'pages/accommodation/overview/AccommodationOverviewPage';
import BookingDatalistPage from 'pages/accommodation/bookings/BookingDatalistPage';
import AccommodationEventPage from 'pages/accommodation/events/AccommodationEventPage';
import BookingFormPage from 'pages/accommodation/bookings/BookingFormPage';
import BookingViewPage, {
    BookingViewPageAdditionalCharges,
    BookingViewPageEvents,
    BookingViewPageView
} from 'pages/accommodation/bookings/BookingViewPage';
import BookingPage from 'pages/accommodation/bookings/BookingPage';
import AccommodationAvailabilityPage from 'pages/accommodation/overview/AccommodationAvailabilityPage';
import AccommodationOverviewStatisticsPage from 'pages/accommodation/overview/AccommodationOverviewStatisticsPage';
import RoomTypeFormPage from 'pages/accommodation/roomTypes/RoomTypeFormPage';
import RoomFormPage from 'pages/accommodation/rooms/RoomFormPage';
import AccommodationSettingsPage from 'pages/accommodation/AccommodationSettingsPage';
import RoomTypeDatalistPage from 'pages/accommodation/roomTypes/RoomTypeDatalistPage';
import RoomDatalistPage from 'pages/accommodation/rooms/RoomDatalistPage';
import EventTemplateDatalistPage from 'pages/accommodation/events/templates/EventTemplateDatalistPage';
import EventTemplateFormPage from 'pages/accommodation/events/templates/EventTemplateFormPage';
import AdditionalChargesTemplateDatalistPage
    from "../pages/accommodation/additional-charges/templates/AdditionalChargesTemplateDatalistPage";
import BookingChannelDatalistPage from 'pages/accommodation/channels/BookingChannelDatalistPage';
import BookingChannelFormPage from 'pages/accommodation/channels/BookingChannelFormPage';
import AccommodationMaintenanceTypeDatalistPage from 'pages/accommodation/settings/maintenance-types/AccommodationMaintenanceTypeDatalistPage';
import RoomAndRoomTypeSettingsPage from 'pages/accommodation/settings/rooms/RoomAndRoomTypeSettingsPage';
import AccommodationMaintenanceDatalistPage from 'pages/accommodation/work/maintenance/AccommodationMaintenanceDatalistPage';
import AccommodationMaintenanceViewPage from 'pages/accommodation/work/maintenance/AccommodationMaintenanceViewPage';
import AccommodationMaintenanceFormPage from 'pages/accommodation/work/maintenance/AccommodationMaintenanceFromPage';
import AccommodationInvestmentDatalistPage from 'pages/accommodation/work/investment/AccommodationInvestmentDatalistPage';
import AccommodationInvestmentViewPage from 'pages/accommodation/work/investment/AccommodationInvestmentViewPage';
import AccommodationInvestmentFormPage from 'pages/accommodation/work/investment/AccommodationInvestmentFormPage';
import { getDefaultView } from 'pages/settings/ui/UISettings';
import WalletPage from 'pages/person/wallet/WalletPage';
import WalletDatalistPage from 'pages/person/wallet/WalletDatalistPage';
import WalletFormPage from 'pages/person/wallet/WalletFormPage';
import WalletViewPage from 'pages/person/wallet/WalletViewPage';
import OfflinePage from 'pages/OfflinePage';
import ApiTokenPage from 'pages/settings/api-token/ApiTokenPage';
import ErrorPage from '@/pages/ErrorPage';
import AccommodationSeasonOverviewPage from '@/pages/accommodation/overview/AccommodationSeasonOverviewPage';
import BookingDatalist from '@/components/entities/accommodation/booking/BookingDatalist';
import BookingDatalistPrintPage from '@/pages/accommodation/bookings/BookingDatalistPrintPage';
import AccommodationEventPrintPage from '@/pages/accommodation/events/AccommodationEventPrintPage';
import AccommodationOverviewPrintPage from '@/pages/accommodation/overview/AccommodationOverviewPrintPage';
import AccommodationAvailabilityPrintPage from '@/pages/accommodation/overview/AccommodationAvailabilityPrintPage';
import NotificationConfigPage from '@/pages/profile/NotificationConfigPage';
import ProfileInfoPage from '@/pages/profile/ProfileInfoPage';
import BookingAttachmentsPage from '@/pages/accommodation/bookings/BookingAttachmentsPage';

type AppRouteType = Omit<RouteObject, 'children'> & {
    roles?: Roles[],
    children?: AppRouteType[]
}

export enum URI_PARAMETER_KEYS {
    ID = 'id',
    TARGET_SEASON_ID = 'targetSeasonId'
}

export enum AppRoutes {
    // #region App
    HOME = '',
    DASHBOARD = '/app/dashboard',
    
    PROFILE = '/app/profile',
    PROFILE_NOTIFICATIONS = '/app/profile/notifications',
    EDIT_PROFILE = '/app/profile/edit',

    DEMO = '/app/demo',
    OFFLINE = '/app/offline',
    UNAUTHORIZED = '/app/unauthorized',
    PERSON_HOME = '/app/person',
    PERSON_VIEW = '/app/person/:id',
    PERSON_FORM = '/app/person/form',
    PERSON_EDIT = '/app/person/form/:id',
    PERSON_TAG_DATALIST = '/app/person/tag',
    PERSON_TAG_VIEW = '/app/person/tag/:id',
    PERSON_TAG_FORM = '/app/person/tag/form',
    PERSON_TAG_EDIT = '/app/person/tag/form/:id',

    PERSON_WALLET_DATALIST = '/app/person/wallet',
    PERSON_WALLET_VIEW = '/app/person/wallet/:id',
    PERSON_WALLET_FORM = '/app/person/wallet/form',
    PERSON_WALLET_EDIT = '/app/person/wallet/form/:id',

    API_TOKEN = '/app/settings/api-token',
    // #endregion App

    // #region Agriculture
    AGRICULTURE_OVERVIEW = '/app/agriculture/overview',
    AGRICULTURE_OVERVIEW_SALE = '/app/agriculture/overview/sale',
    AGRICULTURE_OVERVIEW_WORK = '/app/agriculture/overview/work',
    AGRICULTURE_OVERVIEW_OTHER = '/app/agriculture/overview/other',
    AGRICULTURE_OVERVIEW_INVESTMENT = '/app/agriculture/overview/investment',
    AGRICULTURE_OVERVIEW_MAINTENANCE = '/app/agriculture/overview/maintenance',
    AGRICULTURE_OVERVIEW_SALE_MULTI_UPDATE = '/app/agriculture/overview/sale-multi-update',
    AGRICULTURE_OVERVIEW_WORK_MULTI_UPDATE = '/app/agriculture/overview/harvest-multi-update',

    AGRICULTURE_SEASON_OVERVIEW = '/app/agriculture/season/:targetSeasonId/overview',
    AGRICULTURE_SEASON_OVERVIEW_SALE = '/app/agriculture/season/:targetSeasonId/overview/sale',
    AGRICULTURE_SEASON_OVERVIEW_WORK = '/app/agriculture/season/:targetSeasonId/overview/work',
    AGRICULTURE_SEASON_OVERVIEW_OTHER = '/app/agriculture/season/:targetSeasonId/overview/other',
    AGRICULTURE_SEASON_OVERVIEW_INVESTMENT = '/app/agriculture/season/:targetSeasonId/overview/investment',
    AGRICULTURE_SEASON_OVERVIEW_MAINTENANCE = '/app/agriculture/season/:targetSeasonId/overview/maintenance',

    AGRICULTURE_SALE_FORM = '/app/agriculture/sale/form',
    AGRICULTURE_SALE_EDIT = '/app/agriculture/sale/form/:id',
    AGRICULTURE_SALE_HOME = '/app/agriculture/sale',
    AGRICULTURE_SALE_VIEW = '/app/agriculture/sale/:id',
    AGRICULTURE_SALE_MULTI_UPDATE = '/app/agriculture/sale/multi-update',

    AGRICULTURE_WORK_HARVEST_FORM = '/app/agriculture/work/harvest/form',
    AGRICULTURE_WORK_HARVEST_EDIT = '/app/agriculture/work/harvest/form/:id',
    AGRICULTURE_WORK_HOME = '/app/agriculture/work',
    AGRICULTURE_WORK_VIEW = '/app/agriculture/work/:id',
    AGRICULTURE_HARVEST_MULTI_UPDATE = '/app/agriculture/work/harvest/multi-update',

    AGRICULTURE_INVESTMENT_FORM = '/app/agriculture/work/investment/form',
    AGRICULTURE_INVESTMENT_EDIT = '/app/agriculture/work/investment/form/:id',
    AGRICULTURE_INVESTMENT = '/app/agriculture/work/investment',
    AGRICULTURE_INVESTMENT_VIEW = '/app/agriculture/work/investment/:id',

    AGRICULTURE_MAINTENANCE_FORM = '/app/agriculture/work/maintenance/form',
    AGRICULTURE_MAINTENANCE_EDIT = '/app/agriculture/work/maintenance/form/:id',
    AGRICULTURE_MAINTENANCE = '/app/agriculture/work/maintenance',
    AGRICULTURE_MAINTENANCE_VIEW = '/app/agriculture/work/maintenance/:id',

    AGRICULTURE_MAINTENANCE_TYPE = '/app/agriculture/work/maintenance',
    AGRICULTURE_MAINTENANCE_TYPE_FORM = '/app/agriculture/work/maintenance/type/form',
    AGRICULTURE_MAINTENANCE_TYPE_EDIT = '/app/agriculture/work/maintenance/type/form/:id',

    AGRICULTURE_FRUIT_FORM = '/app/agriculture/fruit/form',
    AGRICULTURE_FRUIT_HOME = '/app/agriculture/fruit/form',
    AGRICULTURE_FRUIT_EDIT = '/app/agriculture/fruit/form/:id',
    // #endregion 

    // #region Accommodation
    ACCOMMODATION_HOME = '/app/accommodation',
    ACCOMMODATION_OVERVIEW_HOME = '/app/accommodation/overview',
    ACCOMMODATION_OVERVIEW_BOOKING = '/app/accommodation/overview/booking',
    ACCOMMODATION_OVERVIEW_EVENT = '/app/accommodation/overview/event',
    ACCOMMODATION_OVERVIEW_AVAILABILITY = '/app/accommodation/overview/availability',
    ACCOMMODATION_OVERVIEW_OVERVIEW = '/app/accommodation/overview/overview',
    ACCOMMODATION_OVERVIEW_INVESTMENT = '/app/accommodation/overview/investment',
    ACCOMMODATION_OVERVIEW_MAINTENANCE = '/app/accommodation/overview/maintenance',

    ACCOMMODATION_SEASON_OVERVIEW_HOME = '/app/accommodation/season/:targetSeasonId/overview',
    ACCOMMODATION_SEASON_OVERVIEW_BOOKING = '/app/accommodation/season/:targetSeasonId/overview/booking',
    ACCOMMODATION_SEASON_OVERVIEW_AVAILABILITY = '/app/accommodation/season/:targetSeasonId/overview/availability',
    ACCOMMODATION_SEASON_OVERVIEW_OVERVIEW = '/app/accommodation/season/:targetSeasonId/overview/overview',
    ACCOMMODATION_SEASON_OVERVIEW_INVESTMENT = '/app/accommodation/season/:targetSeasonId/overview/investment',
    ACCOMMODATION_SEASON_OVERVIEW_MAINTENANCE = '/app/accommodation/season/:targetSeasonId/overview/maintenance',

    ACCOMMODATION_BOOKING_DATALIST = '/app/accommodation/booking',
    ACCOMMODATION_BOOKING_FORM = '/app/accommodation/booking/form',
    ACCOMMODATION_BOOKING_EDIT = '/app/accommodation/booking/form/:id',
    ACCOMMODATION_BOOKING_VIEW = '/app/accommodation/booking/:id',
    ACCOMMODATION_BOOKING_VIEW_ADDITIONAL_CHARGES = '/app/accommodation/booking/:id/additional-charges',
    ACCOMMODATION_BOOKING_VIEW_EVENTS = '/app/accommodation/booking/:id/events',
    ACCOMMODATION_BOOKING_VIEW_ATTACHMENTS = '/app/accommodation/booking/:id/attachments',

    ACCOMMODATION_ROOM_AND_TYPE_SETTINGS = '/app/accommodation/settings/room-and-types',

    ACCOMMODATION_ROOM_TYPE_DATALIST = '/app/accommodation/settings/room-type',
    ACCOMMODATION_ROOM_TYPE_FORM = '/app/accommodation/settings/room-type/form',
    ACCOMMODATION_ROOM_TYPE_EDIT = '/app/accommodation/settings/room-type/form/:id',
    // ACCOMMODATION_ROOM_TYPE_VIEW = '/app/accommodation/settings/room-type/:id',

    ACCOMMODATION_ROOM_EDIT = '/app/accommodation/settings/room/form/:id',
    ACCOMMODATION_ROOM_FORM = '/app/accommodation/settings/room/form',
    ACCOMMODATION_ROOM_DATALIST = '/app/accommodation/settings/room',

    ACCOMMODATION_EVENT_TEMPLATE_DATALIST = '/app/accommodation/settings/event-template',
    ACCOMMODATION_EVENT_TEMPLATE_FORM = '/app/accommodation/settings/event-template/form',
    ACCOMMODATION_EVENT_TEMPLATE_EDIT = '/app/accommodation/settings/event-template/form/:id',

    ACCOMMODATION_CHANNELS = '/app/accommodation/settings/channels',
    ACCOMMODATION_CHANNELS_FORM = '/app/accommodation/settings/channels/form',
    ACCOMMODATION_CHANNELS_EDIT = '/app/accommodation/settings/channels/form/:id',

    ACCOMMODATION_ADDITIONAL_CHARGES_TEMPLATE_DATALIST = '/app/accommodation/settings/additional-charges-template',

    ACCOMMODATION_MAINTENANCE_TYPE = '/app/accommodation/settings/maintenance-type',

    ACCOMMODATION_MAINTENANCE_FORM = '/app/accommodation/work/maintenance/form',
    ACCOMMODATION_MAINTENANCE_EDIT = '/app/accommodation/work/maintenance/form/:id',
    ACCOMMODATION_MAINTENANCE = '/app/accommodation/work/maintenance',
    ACCOMMODATION_MAINTENANCE_VIEW = '/app/accommodation/work/maintenance/:id',

    ACCOMMODATION_INVESTMENT_FORM = '/app/accommodation/work/investment/form',
    ACCOMMODATION_INVESTMENT_EDIT = '/app/accommodation/work/investment/form/:id',
    ACCOMMODATION_INVESTMENT = '/app/accommodation/work/investment',
    ACCOMMODATION_INVESTMENT_VIEW = '/app/accommodation/work/investment/:id',

    // #endregion 

    // #region Template
    TEMPLATE_HARVEST_FORM = '/app/template/agriculture/harvest/form',
    TEMPLATE_HARVEST_EDIT = '/app/template/agriculture/harvest/form/:id',
    TEMPLATE_SALE_FORM = '/app/template/agriculture/sale/form',
    TEMPLATE_SALE_EDIT = '/app/template/agriculture/sale/form/:id',
    // #endregion 

    // #region Settings
    SETTINGS = '/app/settings',
    SEASON_HOME = '/app/settings/season',
    SEASON_FORM = '/app/season/form',
    SEASON_EDIT = '/app/season/form/:id',
    SEASON_VIEW = '/app/season/:id',

    USER_HOME = '/app/settings/user',
    USER_EDIT = '/app/user/form/:id',
    USER_VIEW = '/app/user/:id',

    SETTINGS_ACCOMMODATION_PAGE = '/app/accommodation/settings',
    // #endregion 

    PRINT_ACCOMMODATION_OVERVIEW = '/print/accommodation/overview',
    PRINT_ACCOMMODATION_BOOKING = '/print/accommodation/bookings',
    PRINT_ACCOMMODATION_BOOKING_SEASON = '/print/accommodation/bookings/season/:targetSeasonId',
    PRINT_ACCOMMODATION_EVENT = '/print/accommodation/events',
    PRINT_ACCOMMODATION_AVAILABILITY = '/print/accommodation/availability',    
}

export const resolveRoute = (route: AppRoutes | string, params: any): string => {
    if (!params || lodash.isEmpty(params)) return route;
    let routeVal = route + '';

    for (let key in params) {
        routeVal = routeVal.replace(':' + key, params[key])
    }

    return routeVal;
}

let homeElement = AppRoutes.DASHBOARD;
const defaultView = getDefaultView();
switch (defaultView) {
    case 'accommodation':
        homeElement = AppRoutes.ACCOMMODATION_OVERVIEW_HOME;
        break;
    case 'agriculture':
        homeElement = AppRoutes.AGRICULTURE_OVERVIEW;
        break;
}


const routes: AppRouteType[] = [
    {
        path: '/app',
        element: <AppIndex />,
        children: [
            {
                path: 'menu',
                element: <AppNav />,
            },
            {
                path: AppRoutes.UNAUTHORIZED,
                element: <UnauthorizedPage />
            },
            {
                path: AppRoutes.HOME,
                element: <Navigate to={homeElement} replace={true} />,
            },
            {
                path: AppRoutes.DASHBOARD,
                element: <Dashboard />
            },
            {
                path: AppRoutes.DEMO,
                element: <DemoPage />
            },
            {
                path: AppRoutes.OFFLINE,
                element: <OfflinePage />
            },
            // #region Profile
            {
                path: AppRoutes.PROFILE,
                element: <ProfilePage />,
                children: [
                    {
                        path: '',
                        element: <ProfileInfoPage />
                    },
                    {
                        path: 'edit',
                        element: <ProfileFormPage />
                    },
                    {
                        path: 'notifications',
                        element: <NotificationConfigPage />
                    }
                ]
            },
            // #endregion profile
            // #region PERSON
            {
                path: 'person',
                element: <PersonPage />,
                roles: [Roles.PERSON_READ],
                children: [
                    {
                        path: "",
                        element: <PersonDatalistPage />
                    },
                    {
                        path: ":id",
                        element: <PersonViewPage />
                    },
                    {
                        path: "form",
                        roles: [Roles.PERSON_WRITE],
                        element: <PersonFormPage />
                    },
                    {
                        path: "form/:id",
                        roles: [Roles.PERSON_WRITE],
                        element: <PersonFormPage />
                    },
                    {
                        path: "tag",
                        roles: [Roles.PERSON_READ],
                        element: <PersonTagPage />,
                        children: [
                            {
                                path: '',
                                element: <PersonTagDatalistPage />
                            },
                            {
                                path: 'form',
                                element: <PersonTagFormPage />,
                                roles: [Roles.PERSON_WRITE]
                            },
                            {
                                path: 'form/:id',
                                element: <PersonTagFormPage />,
                                roles: [Roles.PERSON_WRITE]
                            },
                            {
                                path: ':id',
                                element: <PersonTagViewPage />
                            }
                        ]
                    },
                    {
                        path: "wallet",
                        roles: [Roles.ADMIN],
                        element: <WalletPage />,
                        children: [
                            {
                                path: '',
                                element: <WalletDatalistPage />
                            },
                            {
                                path: 'form',
                                element: <WalletFormPage />,
                            },
                            {
                                path: 'form/:id',
                                element: <WalletFormPage />,
                            },
                            {
                                path: ':id',
                                element: <WalletViewPage />
                            }
                        ]
                    }
                ]
            },
            // #endregion PERSON
            { // agriculture
                path: 'agriculture',
                element: <AgriculturePage />,
                roles: [Roles.AGRICULTURE_WORK_READ, Roles.AGRICULTURE_SALES_READ],
                children: [
                    { // overview
                        path: 'overview',
                        element: <AgricultureOverviewPage />,
                        children: [
                            {
                                path: '',
                                element: <AgricultureStatsPage />
                            },
                            {
                                path: 'sale',
                                element: <SaleDatalistPage />,
                                roles: [Roles.AGRICULTURE_SALES_READ]
                            },
                            {
                                path: 'work',
                                element: <HarvestListPage />,
                                roles: [Roles.AGRICULTURE_WORK_READ]
                            },
                            {
                                path: 'investment',
                                element: <AgricultureInvestmentDatalistPage />,
                                roles: [Roles.AGRICULTURE_WORK_READ]
                            },
                            {
                                path: 'maintenance',
                                element: <AgricultureMaintenanceDatalistPage />,
                                roles: [Roles.AGRICULTURE_WORK_READ]
                            },
                            {
                                path: 'other',
                                element: <AgricultureOtherPage />,
                                roles: [Roles.AGRICULTURE_WORK_READ, Roles.AGRICULTURE_SALES_READ]
                            },
                            {
                                path: 'other',
                                element: <AgricultureOtherPage />,
                                roles: [Roles.AGRICULTURE_WORK_READ, Roles.AGRICULTURE_SALES_READ]
                            },
                            {
                                path: 'sale-multi-update',
                                element: <SaleMultiUpdatePage />,
                                roles: [Roles.AGRICULTURE_SALES_WRITE]
                            },
                            {
                                path: 'harvest-multi-update',
                                element: <HarvestMultiUploadPage />,
                                roles: [Roles.AGRICULTURE_WORK_WRITE]
                            }
                        ]
                    },
                    { // sale
                        path: 'sale',
                        element: <SalePage />,
                        roles: [Roles.AGRICULTURE_SALES_READ],
                        children: [{
                            path: '',
                            element: <SaleDatalistPage />
                        }, {
                            path: 'form',
                            element: <SaleFormPage />,
                            roles: [Roles.AGRICULTURE_SALES_WRITE]
                        }, {
                            path: 'form/:id',
                            element: <SaleFormPage />,
                            roles: [Roles.AGRICULTURE_SALES_WRITE]
                        },
                        {
                            path: 'multi-update',
                            element: <SaleMultiUpdatePage />,
                            roles: [Roles.AGRICULTURE_SALES_WRITE]
                        },
                        {
                            path: ':id',
                            element: <SaleViewPage />
                        }]
                    },
                    { // work
                        path: 'work',
                        element: <WorkPage />,
                        roles: [Roles.AGRICULTURE_WORK_READ],
                        children: [
                            {
                                path: '',
                                element: <HarvestListPage />
                            },
                            {
                                path: ':id',
                                element: <WorkViewPage />
                            },
                            {
                                path: 'harvest',
                                children: [
                                    {
                                        path: 'multi-update',
                                        element: <HarvestMultiUploadPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                    {
                                        path: 'form',
                                        element: <HarvestsFormPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <HarvestsFormPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                ]
                            },
                            {
                                path: 'investment',
                                roles: [Roles.AGRICULTURE_WORK_READ],
                                children: [
                                    {
                                        path: '',
                                        element: <AgricultureInvestmentDatalistPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    },
                                    {
                                        path: ':id',
                                        element: <AgricultureInvestmentViewPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    },
                                    {
                                        path: 'form',
                                        element: <AgricultureInvestmentFormPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <AgricultureInvestmentFormPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                    {
                                        path: 'overview',
                                        element: <AgricultureInvestmentHome />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    }
                                ]
                            },
                            {
                                path: 'maintenance',
                                roles: [Roles.AGRICULTURE_WORK_READ],
                                children: [
                                    {
                                        path: '',
                                        element: <AgricultureMaintenanceDatalistPage />,
                                    },
                                    {
                                        path: ':id',
                                        element: <AgricultureMaintenanceViewPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    },
                                    {
                                        path: 'form',
                                        element: <AgricultureMaintenanceFormPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <AgricultureMaintenanceFormPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    },
                                    {
                                        path: 'overview',
                                        element: <AgricultureMaintenanceHomePage />,
                                    },
                                    {
                                        path: 'type',
                                        children: [
                                            {
                                                path: '',
                                                element: <AgricultureMaintenanceTypeHomePage />,
                                            },
                                            {
                                                path: 'form',
                                                element: <AgricultureMaintenanceTypeFormPage />,
                                            },
                                            {
                                                path: 'form/:id',
                                                element: <AgricultureMaintenanceTypeFormPage />,
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    { // fruit
                        path: 'fruit',
                        element: <FruitPage />,
                        roles: [Roles.AGRICULTURE_SALES_READ, Roles.AGRICULTURE_WORK_READ],
                        children: [
                            {
                                path: 'form',
                                element: <FruitFormPage />
                            },
                            {
                                path: 'form/:id',
                                element: <FruitFormPage />
                            }
                        ]
                    },
                    { // season
                        path: `season/:${URI_PARAMETER_KEYS.TARGET_SEASON_ID}`,
                        children: [
                            { // overview
                                path: 'overview',
                                element: <AgricultureOverviewPage />,
                                children: [
                                    {
                                        path: '',
                                        element: <AgricultureStatsPage />
                                    },
                                    {
                                        path: 'sale',
                                        element: <SaleDatalistPage />,
                                        roles: [Roles.AGRICULTURE_SALES_READ]
                                    },
                                    {
                                        path: 'work',
                                        element: <HarvestListPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    },
                                    {
                                        path: 'investment',
                                        element: <AgricultureInvestmentDatalistPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    },
                                    {
                                        path: 'maintenance',
                                        element: <AgricultureMaintenanceDatalistPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ]
                                    },
                                    {
                                        path: 'other',
                                        element: <AgricultureOtherPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ, Roles.AGRICULTURE_SALES_READ]
                                    },
                                    {
                                        path: 'other',
                                        element: <AgricultureOtherPage />,
                                        roles: [Roles.AGRICULTURE_WORK_READ, Roles.AGRICULTURE_SALES_READ]
                                    },
                                    {
                                        path: 'sale-multi-update',
                                        element: <SaleMultiUpdatePage />,
                                        roles: [Roles.AGRICULTURE_SALES_WRITE]
                                    },
                                    {
                                        path: 'harvest-multi-update',
                                        element: <HarvestMultiUploadPage />,
                                        roles: [Roles.AGRICULTURE_WORK_WRITE]
                                    }
                                ]
                            }
                        ]
                    }
                ],
            },
            { // Templates
                path: 'template',
                element: <TemplatePage />,
                children: [
                    {
                        path: 'agriculture',
                        children: [
                            {
                                path: 'harvest',
                                roles: [Roles.AGRICULTURE_WORK_WRITE],
                                children: [
                                    {
                                        path: 'form',
                                        element: <WorkTemplateFormPage />
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <WorkTemplateFormPage />
                                    }
                                ]
                            },
                            {
                                path: 'sale',
                                roles: [Roles.AGRICULTURE_SALES_WRITE],
                                children: [
                                    {
                                        path: 'form',
                                        element: <SaleTemplateFormPage />
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <SaleTemplateFormPage />
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            { // season
                path: 'season',
                element: <SeasonPage />,
                children: [
                    {
                        path: '',
                        element: <SeasonDatalistPage />
                    },
                    {
                        path: 'form',
                        roles: [Roles.ADMIN],
                        element: <SeasonFormPage />
                    },
                    {
                        path: 'form/:id',
                        roles: [Roles.ADMIN],
                        element: <SeasonFormPage />
                    },
                    {
                        path: ':id',
                        element: <SeasonViewPage />
                    }
                ]
            },
            { // user
                path: 'user',
                element: <UserPage />,
                roles: [Roles.ADMIN],
                children: [
                    {
                        path: '',
                        element: <UserDatalistPage />
                    },
                    {
                        path: 'form/:id',
                        element: <UserFormPage />
                    },
                    {
                        path: ':id',
                        element: <UserViewPage />
                    }
                ]
            },
            { // settings
                path: 'settings',
                element: <SettingsPage />,
                children: [
                    {
                        path: 'user',
                        roles: [Roles.ADMIN],
                        children: [
                            {
                                path: '',
                                element: <UserDatalistPage />
                            }
                        ]
                    },
                    {
                        path: 'season',
                        element: <SeasonPage />,
                        roles: [Roles.ADMIN],
                        children: [
                            {
                                path: '',
                                element: <SeasonDatalistPage />
                            }
                        ]
                    },
                    {
                        path: 'api-token',
                        element: <ApiTokenPage />,
                        roles: [Roles.ADMIN]
                    }
                ]
            },
            { // accommodation
                path: 'accommodation',
                element: <AccommodationPage />,
                roles: [Roles.ACCOMMODATION_BOOKINGS_READ],
                children: [
                    { // overview
                        path: "overview",
                        element: <AccommodationOverviewPage />,
                        children: [
                            {
                                path: '',
                                element: <BookingDatalistPage />,
                                roles: [Roles.ACCOMMODATION_BOOKINGS_READ]
                            },
                            {
                                path: 'booking',
                                element: <BookingDatalistPage />,
                                roles: [Roles.ACCOMMODATION_BOOKINGS_READ]
                            },
                            {
                                path: 'event',
                                element: <AccommodationEventPage />,
                                roles: [Roles.ACCOMMODATION_BOOKINGS_READ]
                            },
                            {
                                path: 'overview',
                                element: <AccommodationOverviewStatisticsPage />,
                                roles: [Roles.ACCOMMODATION_BOOKINGS_READ, Roles.ACCOMMODATION_WORK_READ]
                            },
                            {
                                path: 'availability',
                                element: <AccommodationAvailabilityPage />,
                                roles: [Roles.ACCOMMODATION_WORK_READ]
                            },
                            {
                                path: 'maintenance',
                                element: <AccommodationMaintenanceDatalistPage />,
                                roles: [Roles.ACCOMMODATION_WORK_READ]
                            },
                            {
                                path: 'investment',
                                element: <AccommodationInvestmentDatalistPage />
                            }
                        ]
                    },
                    { // booking
                        path: 'booking',
                        element: <BookingPage />,
                        children: [
                            {
                                path: '',
                                element: <BookingDatalistPage />,
                            },
                            {
                                path: 'form',
                                element: <BookingFormPage />,
                                roles: [Roles.ACCOMMODATION_BOOKINGS_WRITE]
                            },
                            {
                                path: 'form/:id',
                                element: <BookingFormPage />,
                                roles: [Roles.ACCOMMODATION_BOOKINGS_WRITE]
                            },
                            {
                                path: ':id',
                                element: <BookingViewPage />,
                                children: [
                                    {
                                        path: '',
                                        element: <BookingViewPageView />
                                    },
                                    {
                                        path: 'additional-charges',
                                        element: <BookingViewPageAdditionalCharges />
                                    },
                                    {
                                        path: 'events',
                                        element: <BookingViewPageEvents />
                                    },
                                    {
                                        path: 'attachments',
                                        element: <BookingAttachmentsPage />
                                    }
                                ]
                            }
                        ]
                    },
                    { // settings
                        path: "settings",
                        roles: [Roles.ADMIN],
                        element: <AccommodationSettingsPage />,
                        children: [
                            { // room types
                                path: "room-type",
                                children: [
                                    {
                                        path: '',
                                        element: <RoomTypeDatalistPage />
                                    },
                                    {
                                        path: 'form',
                                        element: <RoomTypeFormPage />,
                                        roles: [Roles.ADMIN]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <RoomTypeFormPage />,
                                        roles: [Roles.ADMIN]
                                    }
                                ]
                            },
                            { // room
                                path: "room",
                                children: [
                                    {
                                        path: '',
                                        element: <RoomDatalistPage />
                                    },
                                    {
                                        path: 'form',
                                        element: <RoomFormPage />,
                                        roles: [Roles.ADMIN]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <RoomFormPage />,
                                        roles: [Roles.ADMIN]
                                    }
                                ]
                            },
                            { // event template
                                path: "event-template",
                                children: [
                                    {
                                        path: '',
                                        element: <EventTemplateDatalistPage />
                                    },
                                    {
                                        path: 'form',
                                        element: <EventTemplateFormPage />,
                                        roles: [Roles.ADMIN]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <EventTemplateFormPage />,
                                        roles: [Roles.ADMIN]
                                    }
                                ]
                            },
                            { // additional charges
                                path: 'additional-charges-template',
                                children: [
                                    {
                                        path: '',
                                        element: <AdditionalChargesTemplateDatalistPage />
                                    }
                                ]
                            },
                            { // channels
                                path: 'channels',
                                children: [
                                    {
                                        path: '',
                                        element: <BookingChannelDatalistPage />
                                    },
                                    {
                                        path: 'form',
                                        element: <BookingChannelFormPage />
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <BookingChannelFormPage />
                                    }
                                ]
                            },
                            { // maintenance-type
                                path: 'maintenance-type',
                                children: [
                                    {
                                        path: '',
                                        element: <AccommodationMaintenanceTypeDatalistPage />
                                    }
                                ]
                            },
                            { // room and types
                                path: 'room-and-types',
                                element: <RoomAndRoomTypeSettingsPage />
                            }
                        ]
                    },
                    { // work
                        path: 'work',
                        roles: [Roles.ACCOMMODATION_WORK_READ],
                        children: [
                            {
                                path: '',
                                element: <AccommodationMaintenanceDatalistPage />
                            },
                            {
                                path: 'maintenance',
                                children: [
                                    {
                                        path: '',
                                        element: <AccommodationMaintenanceDatalistPage />
                                    },
                                    {
                                        path: ':id',
                                        element: <AccommodationMaintenanceViewPage />
                                    },
                                    {
                                        path: 'form',
                                        element: <AccommodationMaintenanceFormPage />,
                                        roles: [Roles.ACCOMMODATION_WORK_WRITE]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <AccommodationMaintenanceFormPage />,
                                        roles: [Roles.ACCOMMODATION_WORK_WRITE]
                                    }
                                ]
                            },
                            {
                                path: 'investment',
                                children: [
                                    {
                                        path: '',
                                        element: <AccommodationInvestmentDatalistPage />
                                    },
                                    {
                                        path: ':id',
                                        element: <AccommodationInvestmentViewPage />
                                    },
                                    {
                                        path: 'form',
                                        element: <AccommodationInvestmentFormPage />,
                                        roles: [Roles.ACCOMMODATION_WORK_WRITE]
                                    },
                                    {
                                        path: 'form/:id',
                                        element: <AccommodationInvestmentFormPage />,
                                        roles: [Roles.ACCOMMODATION_WORK_WRITE]
                                    }
                                ]
                            }
                        ]
                    },
                    { //season
                        path: `season/:${URI_PARAMETER_KEYS.TARGET_SEASON_ID}`,
                        children: [
                            { // overview
                                path: "overview",
                                element: <AccommodationSeasonOverviewPage />,
                                children: [
                                    {
                                        path: '',
                                        element: <BookingDatalistPage />,
                                        roles: [Roles.ACCOMMODATION_BOOKINGS_READ]
                                    },
                                    {
                                        path: 'booking',
                                        element: <BookingDatalistPage />,
                                        roles: [Roles.ACCOMMODATION_BOOKINGS_READ]
                                    },
                                    {
                                        path: 'overview',
                                        element: <AccommodationOverviewStatisticsPage />,
                                        roles: [Roles.ACCOMMODATION_BOOKINGS_READ, Roles.ACCOMMODATION_WORK_READ]
                                    },
                                    {
                                        path: 'availability',
                                        element: <AccommodationAvailabilityPage />,
                                        roles: [Roles.ACCOMMODATION_WORK_READ]
                                    },
                                    {
                                        path: 'maintenance',
                                        element: <AccommodationMaintenanceDatalistPage />,
                                        roles: [Roles.ACCOMMODATION_WORK_READ]
                                    },
                                    {
                                        path: 'investment',
                                        element: <AccommodationInvestmentDatalistPage />
                                    }
                                ]
                            },
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: '/print',
        element: <AppPrinter />,
        children: [
            {
                path: '',
                element: <div>Print home</div>
            },

            { // accommodation
                path: 'accommodation',
                element: <AccommodationPage />,
                roles: [Roles.ACCOMMODATION_BOOKINGS_READ],
                children: [
                    { // booking
                        path: "bookings",
                        element: <BookingDatalistPrintPage />
                    },
                    { // booking
                        path: "bookings/season/:targetSeasonId",
                        element: <BookingDatalistPrintPage />
                    },
                    { // event
                        path: "events",
                        element: <AccommodationEventPrintPage />
                    },
                    { // overview
                        path: "overview",
                        element: <AccommodationOverviewPrintPage />
                    },
                    { // availability
                        path: "availability",
                        element: <AccommodationAvailabilityPrintPage />
                    
                    }
                ]
            }
        ]
    },
    {
        path: '/',
        element: <Navigate to="/app" replace={true} />
    }
];


function hasRole(user: IUser, roles?: string[]) {
    if (!roles?.length) return true;
    if (user.roles.indexOf(Roles.ADMIN) > -1) return true;
    return user.roles.some(r => roles.indexOf(r) > -1);
}

function resolveRoutes(user: IUser, routes: AppRouteType[], isParentAllowed: boolean) {
    const sessionRoutes: RouteObject[] = [];
    for (let index = 0; index < routes.length; index++) {
        const route = routes[index];
        const hasPermission = isParentAllowed && hasRole(user, route.roles);
        const sessionRoute: RouteObject = {
            element: hasPermission ? route.element : <UnauthorizedPage reason='No permission' />,
            path: route.path,
            children: undefined,
            errorElement: <ErrorPage />
        };

        if (route.children?.length) {
            const routeChildren = resolveRoutes(user, route.children, hasPermission);
            if (routeChildren?.length) {
                sessionRoute.children = routeChildren;
            }
        }

        sessionRoutes.push(sessionRoute);
    }

    return sessionRoutes;
}

const router = (user: IUser) => {
    const sessionRoutes = resolveRoutes(user, routes, true);
    return createBrowserRouter(sessionRoutes);
}

export default router; 
